import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import {
  createYear,
  getYear,
  getYears,
  editYear,
  deleteYear,
} from "api/yearApi"

export const YEAR_QUERY_KEY = "years"

export const useYears = (params = {}, enabled = true) => {
  return useQuery({
    queryKey: [YEAR_QUERY_KEY, params],
    queryFn: () => getYears(params),
    keepPreviousData: true,
    enabled
  })
}

export const useYear = (id) => {
  return useQuery({
    queryKey: [YEAR_QUERY_KEY, id],
    queryFn: () => getYear(id),
    enabled: !!id,
  })
}

export const useCreateYear = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createYear,
    onSuccess: (data) => {
      if (data?.success) {
        queryClient.invalidateQueries([YEAR_QUERY_KEY])
      }
    },
  })
}

export const useEditYear = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: editYear,
    onSuccess: (data) => {
      if (data?.success) {
        queryClient.invalidateQueries([YEAR_QUERY_KEY])
      }
    },
  })
}

export const useDeleteYear = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteYear,
    onSuccess: (data) => {
      if (data?.success) {
        queryClient.invalidateQueries([YEAR_QUERY_KEY])
      }
    },
  })
}
